module.exports = __webpack_public_path__ + "static/media/DuplicateSlab-Heavy.ea5cee24.woff";